<template>
  <div class="container">
    <div class="level">
      <div class="level-left">
        <button
          class="button is-primary is-badge-info"
          type="submit"
          @click="refresh(true)"
          :disabled="isLoading || isError"
          :data-badge="pending"
          :class="{ badge: pending }"
        >
          <b-icon icon="refresh"></b-icon>
          <span>
            Neue Bestellungen abholen
          </span>
        </button>
      </div>
      <div class="level-right">
        <b-field>
          <b-input
            placeholder="Bibliothek"
            icon="magnify"
            v-model="library"
            v-on:keyup.native.enter="refresh(false)"
          ></b-input>
          <p class="control">
            <button
              class="button is-primary"
              type="submit"
              @click="refresh(false)"
              :disabled="isLoading"
            >
              <b-icon icon="arrow-right-drop-circle-outline"></b-icon>
              <span>
                Bibliothek ändern
              </span>
            </button>
          </p>
        </b-field>
      </div>
    </div>
    <b-message v-if="apiError" type="is-danger" :closable="false">
      {{ apiError }}
    </b-message>
    <div class="container">
      <b-table
        :data="batches"
        :paginated="true"
        :loading.sync="isLoading"
        :per-page="10"
        :pagination-simple="true"
        :current-page.sync="currentPage"
        v-if="batches"
      >
        <b-table-column field="new" label="Neu" v-slot="props">
          <span v-if="props.row.new">
            <b-icon icon="star" class="has-text-warning"></b-icon>
          </span>
        </b-table-column>
        <b-table-column field="batchid" label="Folgenummer" v-slot="props">
          {{ props.row.batchid }}
        </b-table-column>
        <b-table-column field="stamp" label="Zeitstempel" v-slot="props">
          {{ props.row.stamp }}
        </b-table-column>
        <b-table-column field="count" label="Anzahl" v-slot="props">
          {{ props.row.count }}
        </b-table-column>
        <b-table-column
          field="action"
          label=" "
          v-slot="props"
          class="has-text-right"
        >
          <button
            class="button"
            v-bind:class="{
              'is-primary': props.row.new,
              'is-light': !props.row.new
            }"
            @click="downloadBatch(props.row.batchid, 'pdf')"
            :disabled="isLoading"
          >
            <b-icon icon="file-pdf"></b-icon>
            <span>
              Herunterladen
            </span>
          </button>
        </b-table-column>
        <b-table-column
          field="details"
          label="  "
          v-slot="props"
          class="has-text-right"
          width="80"
          v-if="enable_info_modal"
        >
          <button
            class="button is-light"
            @click="batchModal(props.row.batchid)"
            :disabled="isLoading"
          >
            <b-icon icon="information-outline"></b-icon>
          </button>
        </b-table-column>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>Keine Daten vorhanden</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import Api from "../api";
import BatchModal from "./BatchModal.vue";

export default {
  data() {
    return {
      batches: null,
      pending: null,
      library: null,
      apiError: "",
      isLoading: false,
      isError: false,
      currentPage: 1,
      enable_info_modal: true
    };
  },
  methods: {
    refresh: async function(do_update) {
      let vm = this;

      vm.isLoading = true;
      vm.apiError = "";

      let qs = "";
      if (vm.library) {
        qs += qs ? "&" : "?";
        qs += "library=" + encodeURIComponent(vm.library);
      }
      if (do_update) {
        qs += qs ? "&" : "?";
        qs += "update=1";
      }

      try {
        const res = await Api.getJSON("get", "list/batches" + qs);
        vm.library = res.library;
        vm.batches = res.batches;
        vm.pending = res.pending;
        vm.isError = false;
        vm.currentPage = 1;
      } catch (error) {
        if (error.response.status == 401) {
          vm.$router.replace({
            path: "/login",
            query: { reason: "sessionExpired", redirect: vm.$route.fullPath }
          });
        }
        vm.apiError = Api.getFirstError(error);
        vm.batches = null;
        vm.pending = 0;
        vm.isError = true;
      }

      vm.isLoading = false;
    },
    downloadBatch: async function(batchid, format) {
      let vm = this;

      vm.isLoading = true;
      vm.apiError = "";

      let url = "get/batch/" + batchid + "/" + format;
      url += "?library=" + encodeURIComponent(vm.library) + "&unmark=true";

      let fn_l = vm.library.replace(/\//g, "_");
      let fn_b = batchid.toString().padStart(6, "0");
      let filename = "wls-" + fn_l + "-" + fn_b + "." + format;

      try {
        const res = await Api.getBlob("post", url);
        let type = res.headers["content-type"];
        let blob = new Blob([res.data], { type: type });
        FileSaver.saveAs(blob, filename);
        for (const row of vm.batches) {
          if (batchid == row.batchid) row.new = false;
        }
      } catch (error) {
        if (error.response.status == 401) {
          vm.$router.replace({
            path: "/login",
            query: { reason: "sessionExpired", redirect: vm.$route.fullPath }
          });
        }
        vm.apiError = Api.getFirstError(error);
      }

      vm.isLoading = false;
    },
    batchModal(batchid) {
      this.$buefy.modal.open({
        parent: this,
        component: BatchModal,
        hasModalCard: true,
        props: {
          library: this.library,
          batchid: batchid
        }
      });
    }
  },
  mounted: function() {
    this.enable_info_modal = process.env.VUE_APP_ENABLE_INFO_MODAL == "Y";
    this.refresh(false);
  }
};
</script>
